import { SearchOffers } from '@lambda/commons/apis/elasticsearch/types';
import Image from 'next/future/image';
import Link from 'next/link';
import cn from 'classnames';
import { calculateSavings, getOfferUri } from '@/lib/offer';
import { priceFormater } from '@/settings/index';

const ProductCard = ({
  offer,
  size = 'base',
}: {
  offer: SearchOffers;
  size?: 'sm' | 'base';
}) => {
  const savingsPercentage = calculateSavings(offer.price, offer.comparePrice);

  return (
    <Link href={getOfferUri(offer)} passHref key={offer.key}>
      <a
        className={cn(
          'flex w-full cursor-pointer flex-col rounded-md border !bg-white p-3 text-left text-xs',
          {
            'h-[250px]': size === 'base',
            'h-[220px]': size === 'sm',
          },
        )}
      >
        <div
          className={cn('relative mt-2 mb-5 w-full', {
            'min-h-[100px] lg:min-h-[75px] xl:min-h-[100px]': size === 'base',
            'min-h-[75px] lg:min-h-[50px] xl:min-h-[75px]': size === 'sm',
          })}
        >
          <Image
            src={offer.imageSrc}
            alt={offer.defaultImageAltTag ?? offer.title}
            fill
            className="object-contain"
            priority
          />
        </div>
        <div className="flex flex-1 flex-col justify-between">
          <h3
            // eslint-disable-next-line tailwindcss/no-custom-classname
            className="two-line-ellipsis text-sm"
          >
            {offer.title.replace(/Oppo/g, 'OPPO')}
          </h3>
          <div className="mt-3 flex flex-wrap-reverse items-end justify-between gap-x-3 gap-y-1">
            <div>
              <h3 className="text-sm font-bold">
                {priceFormater.long(offer.price)}
              </h3>
              {offer.comparePrice && savingsPercentage > 3 && (
                <h4 className="text-xs text-gray-700/30">
                  new{' '}
                  <span className="line-through">
                    {priceFormater.long(offer.comparePrice)}
                  </span>
                </h4>
              )}
            </div>
            {savingsPercentage > 3 && (
              <div className="place-self-end rounded bg-red px-2.5 py-1 text-xs text-white">
                Save {savingsPercentage}%
              </div>
            )}
          </div>
        </div>
      </a>
    </Link>
  );
};

export default ProductCard;
